import React, { useState, useEffect } from "react";

const url = process.env.REACT_APP_TRANSLATION_URL;

const Translations = () => {
  const [translations, setTranslations] = useState([]);

  useEffect(() => {
    getTranslationsDoc();
  }, []);

  const getTranslationsDoc = async () => {
    const data = await fetch(url).then((response) => response.json());
    setTranslations(data);
  };

  return (
    <React.Fragment>
      <blockquote>
        <p>
          Cette liste est disponible <a href={url} target="_blank">au format JSON</a> pour pouvoir être manipulée plus
          facilement. Il est important de noter que la première partie de la chaîne correspond au nom du fichier.
        </p>
      </blockquote>
      <table style={{ minHeight: 1000 }}>
        <thead>
          <tr>
            <th>Clé</th>
            <th>Contexte</th>
            <th>Paramètres</th>
          </tr>
        </thead>
        <tbody>
          {translations.map((t) => (
            <tr>
              <td>
                <code>{t.message}</code>
              </td>
              <td>{t.context}</td>
              <td>
                {t.parameters &&
                  Object.entries(t.parameters).map((p) => (
                    <p>
                      <strong>{p[0]}</strong> : {p[1]}
                    </p>
                  ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default Translations;



// WEBPACK FOOTER //
// ./src/components/TranslationTable.js